<template>
  <div class="bx-header__search bx-typo--header-search">
    <a ref="headerSearchOpener"
       aria-label="Suche öffnen"
       class="icon icon--header-search"
       tabindex="0"
       @click="toggleSearch()"
       @keyup.enter="toggleSearch()">
      <svg><use href="#search" /></svg>
    </a>
    <form ref="headerSearchForm"
          class="bx-form bx-typo--form bx-form--search-header bx-typo--form-search-header"
          onsubmit="return false;"
          @submit="submitSearch()">
      <input id="bx-header-search-input"
             v-model="searchPhrase"
             type="search"
             class="bx-form__input"
             title="AUTO ZEITUNG durchsuchen"
             placeholder="AUTO ZEITUNG durchsuchen">
      <button aria-label="Suchen"
              class="bx-form__search-submit"
              tabindex="-1"
              @click="submitSearch()"
              @keyup.enter="submitSearch()">
        <Icon name="search" />
      </button>
      <a aria-label="Suche schliessen"
         class="icon icon--header-close"
         tabindex="0"
         @click="toggleSearch()"
         @keyup.enter="toggleSearch()">
        <svg><use href="#close" /></svg>
      </a>
    </form>
  </div>
</template>

<script>
import { useKeepTabbingFocus } from '../../../composables/use-keep-tabbing-focus'
import Icon from '../../../components/shared/Icon.vue'

export default {
  components: { Icon },
  setup () { return useKeepTabbingFocus() },
  data () {
    return {
      searchPhrase: '',
      showSearch: false
    }
  },
  methods: {
    toggleSearch () {
      this.showSearch = document.body.classList.toggle('bx-js-show-search')
      if (this.showSearch) {
        this.$refs.headerSearchForm.querySelector('#bx-header-search-input').focus()
        this.keepTabbingFocusInHeaderSearch()
      }
    },
    submitSearch () {
      window.location.href = `/suche?query=${encodeURIComponent(document.getElementById('bx-header-search-input').value.trim())}`
    },
    keepTabbingFocusInHeaderSearch () {
      this.$nextTick(() => {
        this.removeTabbingEventListeners()
        this.keepTabbingFocus(this.$refs.headerSearchForm, ['input, a'], 0, () => {
          this.removeTabbingEventListeners()
          this.toggleSearch()
          this.$refs.headerSearchOpener.focus()
        })
      })
    }
  }
}
</script>
